<div class="flex flex_column gap-3">
  <div class="qr-main">
    <div class="flex flex_column qr-left-container">
      <div class="how-it-works gap-3 flex flex_column">
        <div class="fs-16 fw-700">How It Works?</div>

        <div *ngFor="let item of howToScan; let i=index">
          <div class="fs-20 fw-700">{{i + 1}}. {{item.title}}</div>
          <div class="fs-14">{{item.description}}</div>
        </div>

      </div>
      <div class="things-to-remember">
        <div class="ttr-header">
          <img class="info-yellow" [src]="images.INFO_YELLOW" alt="Info" />
          Things to remember
        </div>
        <ol class="info-list fw-600 fs-14" type="1">
          <li>If a payment fails, click "Regenerate QR" to retry the payment.</li>
          <li>Multiple simultaneous scans can cause DuitNow Payment to fail. Regenerate the QR code to initiate the
            payment again.</li>
          <li>Ensure that the user points the device away from the QR after scanning to prevent transaction failures.
          </li>
          <li>Deducted amounts due to failures will be automatically refunded within 7-14 days.</li>
        </ol>
      </div>
    </div>
    <div class="qr-right-container flex_column justify-center flex-center">
      <div class="flex flex_column flex-center">
        <img *ngIf="!qrData" class="qr-loader" [src]="images.QR_LOADER" alt="QR CODE" />
        <canvas class="qr-img" [ngClass]="{ 'no-qr': !qrData }" #qrCodeCanvas></canvas>
        <img *ngIf="customCloseIcon" [src]="images.MODAL_CLOSE_RED" class="modal__close" (click)="closeModal()"
          alt="close" />
        <div *ngIf="!qrData" class="regenerate-qr">Re generating QR...</div>
      </div>
      <button class="regenerate-button" (click)="regenerateQrFunc()">Regenerate QR</button>
    </div>
  </div>
  <div class="fs-16 fw-600">Mobile Banking and eWallet apps we support:</div>
  <div class="flex w-100 flex_sb gap-3">
    <ng-container *ngFor="let item of dnImages">
      <img [class]="item.class" [src]="item.img" alt="Info" />
    </ng-container>
    <div class="view-more fs-16 fw-700 text-line" (click)="updateViewMore()">View {{viewMore ? 'Less': 'More'}}</div>
  </div>
  <img id="dn-all" *ngIf="viewMore" class="dn-all" [src]="images.DN_ALL" alt="Info" />
</div>